<template>
  <SidebarPage>
    <template #sidebar>
      <CharacteristicGroupsRegistry v-model="selectedGroup"/>
    </template>

    <template #page>
      <CharacteristicsRegistry :selected-group="selectedGroup"/>
    </template>
  </SidebarPage>
</template>

<script lang="ts">
import CharacteristicGroupsRegistry from '@/domains/CharacteristicGroups/components/CharacteristicGroupsRegistry.vue';
import CharacteristicsRegistry      from '@/domains/Characteristics/components/CharacteristicsRegistry.vue';

import type CharacteristicGroup from '@/domains/CharacteristicGroups/CharacteristicGroup';

export default defineComponent({
  name: 'CharacteristicsPage',

  components: {
    CharacteristicGroupsRegistry,
    CharacteristicsRegistry,
  },

  data() {
    return {
      selectedGroup: null as CharacteristicGroup | null,
    };
  },
});
</script>
